<div class="col-sm-11 center-block  extra-top-space" [@fadeInOut] >
    <div class="row">

            <div class="col-md-10 center-block extra-top-space mt-5 pt-5">
                <div class="col-md-4 extra-top-space" style="position: relative">
									<span class="primary">
										<i class="fal fa-user-lock fa-9x"></i>
									</span>
                </div>
                <div class="col-md-8 extra-top-space">
                    <h1>We're sorry, but it looks like you don't have permission to access this application.</h1>
                    <p>
                        {{message}}
                    </p>
                    <p>
                      If you're having trouble with tasks like ingesting a file, passing validation for a device or creating submission items, please don't hesitate to contact us via email at
                      <a href="mailto:customer.support@reedtech.com">customer.support&#64;reedtech.com</a>.
                    </p>
                </div>
            </div>


    </div>
</div>
